import { render, staticRenderFns } from "./GoodsTeeView.vue?vue&type=template&id=15adc2da&"
import script from "./GoodsTeeView.vue?vue&type=script&lang=js&"
export * from "./GoodsTeeView.vue?vue&type=script&lang=js&"
import style0 from "./GoodsTeeView.vue?vue&type=style&index=0&id=15adc2da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports